export const apiContextPath = '/api/skattemelding-core/';
export const webContextPath = '/';
